import Vue from "vue";
import App from "./app/App.vue";
import router from "./app/router";
import vuetify from "./app/plugins/vuetify";
import { createPinia, PiniaVuePlugin } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { VueMaskDirective } from "v-mask";
import { Amplify } from "aws-amplify";
import i18n from "./i18n";
import GetTextPlugin from "vue-gettext";
import VueCookies from "vue-cookies";

Vue.use(GetTextPlugin, { translations: {}, silent: true });

// VueCookies
Vue.use(VueCookies);
// AWS Cognito
Amplify.configure({
  Auth: {
    region: process.env.VUE_APP_COGNITO_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_WEB_CLIENT_ID,
  },
});

// V-Mask
Vue.directive("mask", VueMaskDirective);

// Pinia
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  pinia,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
